var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"background-color":"var(--card-type2-color)"}},[_c('PersonalBanner'),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-zsy"},[_c('div',{staticClass:"title-wrap"},[_c('h3',[_vm._v("수상/보도")]),_c('h4',[_vm._v("믿을 수 있는 "),_c('br',{staticClass:"visible-xs"}),_vm._v("중국 전문 배대지"),_c('br'),_vm._v("압도적 회원수 1위 고로켓고")])]),_c('br')])
}]

export { render, staticRenderFns }